/**
 * @description URL query parameters used for authentication redirects
 * @example
 * // For Symfony-based applications, the query parameter is `_target_path`
 * https://example.com/login?_target_path=/dashboard
 *
 * // For React-based applications, the query parameter is `targetPath`
 * https://example.com/login?targetPath=/dashboard
 */
export enum AuthRedirectQueryParams {
  symfony = '_target_path',
  react = 'targetPath',
}

/**
 * @description URL query parameters used for user token authentication
 * @example
 * // The user token is used for impersonation or magic link authentication.
 * https://example.com/login?user_token=abc123
 */
export enum AuthUserTokenQueryParams {
  userToken = 'user_token',
  impersonateToken = 'impersonate_token',
  loginToken = 'login_token',
}

/**
 * @description Regex pattern for validating email addresses or phone numbers
 * - Original pattern: "^(?:[\S]+@[\S]+\.[a-zA-Z]{2,}|(?:\+?(?:[\s\(\)\.\-]*\d){7,15}[\s\(\)\.\-]*))$"
 */
export const EMAIL_OR_PHONE_PATTERN = '^(?:[\\S]+@[\\S]+\\.[a-zA-Z]{2,}|(?:\\+?(?:[\\s\\(\\)\\.\\-]*\\d){7,15}[\\s\\(\\)\\.\\-]*))$';

/**
 * @description URL for the paged used for checking the validity of a magic link.
 */
export const MAGIC_LINK_CHECK_URL = '/login-link';
export const AUTO_LOGIN_CHECK_URL = '/auto-login';
export const IMPERSONATE_CHECK_URL = '/impersonate';

/**
 * @description Name of the NextAuth session cookie. NextAuth v5 sets this on
 * successful sign-in; middleware and the silent-recovery route both need to
 * read or clear it to manage stale-session edge cases.
 */
export const NEXTAUTH_SESSION_COOKIE_NAME = '_ast';
